export default __webpack_public_path__ + "static/media/disabledPlusIcon.6d127568.svg";